import { useEffect, useState } from "react"

const PREFIX = "access-control-"

const useSessionStorage = (key: string, defaultValue: string): [string, (value: string) => void] => {
	const [stored, setStored] = useState(defaultValue)
	useEffect(() => {
		const value = sessionStorage.getItem(PREFIX + key)
		if (value) setStored(value)
	}, [key])
	const setValue = (value: string) => {
		sessionStorage.setItem(PREFIX + key, value)
		setStored(value)
	}
	return [stored, setValue]
}
export default useSessionStorage
